import { render } from "./CertificationDialog.vue?vue&type=template&id=16fd2468&scoped=true&ts=true"
import script from "./CertificationDialog.vue?vue&type=script&lang=ts"
export * from "./CertificationDialog.vue?vue&type=script&lang=ts"

import "./CertificationDialog.vue?vue&type=style&index=0&id=16fd2468&scoped=true&lang=scss"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fd2468"]])

export default __exports__